import React, { FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getClientIdParamValue } from '../../utils/helpers';
import { PROBLEM_WITH_ACCOUNT_EVENT } from '../../utils/analytics/analyticsEvents';
import { capturePageLoadAnalytics } from '../../utils/analytics/analyticsDispatchers';
import { getStopByPageErrorContent } from '../../store/contentSlice';

const StopByPageError: FunctionComponent = () => {
  const clientId = getClientIdParamValue();
  const { heading, message }: any = useSelector((state: any) =>
    getStopByPageErrorContent(state, clientId),
  );
  useEffect(() => {
    capturePageLoadAnalytics(PROBLEM_WITH_ACCOUNT_EVENT);
  }, []);

  return (
    <div className="error-text-wrapper" data-testid="stop-by-page-error-screen">
      <p className="heading-text">{heading}</p>
      <p className="fatal-error-text">{message}</p>
    </div>
  );
};

export default StopByPageError;
